export const DATE_FORMAT = 'yyyy-MM-dd';
export const ROW_HEIGHT = 55;
export const HEADER_HEIGHT = 100;
export const LEFT_WIDTH = 120;
export const COLUMN_WIDTH = 140;
export const TOP_HEIGHT = 100;

export interface CompanyOption {
  cid: string;
  name: string;
}

export interface NetworkOption {
  network: string;
  platform: string;
  description?: string;
  derived_id?: string;
}

export type SelectedGroup = CompanyOption | NetworkOption;

export interface Flight {
  orderID: string;
  startDate: string;
  endDate: string;
  spend: number;
  cpm?: number;
  impressions: number;
  properties?: string[];
  canceled?: string;
  overrides?: { spend: number; impressions: number };
  derivedNetwork?: string;
  pdfText?: string;
}

export interface FlightData {
  flightMap?: Record<string, Flight>;
}

// The `/device_breakout` lambda branches entirely on whether it receives a `company` or a
// `network` param, and returns a different (non-overlapping) shape for each.
export interface DeviceBreakoutCompanyData {
  deviceList: string[];
  networkList: string[];
  totalImpsByNetwork: Record<string, number>;
  networkDeviceMap: Record<string, Record<string, number>>;
  placementToFlightsMap: Record<string, string[]>;
}

export interface DeviceBreakoutNetworkData {
  deviceList: string[];
  companyList: string[];
  totalImpsByCompany: Record<string, number>;
  companyDeviceMap: Record<string, Record<string, number>>;
}

export interface DeviceCell {
  count: string;
  percentage: string;
  combinedPlacementName?: string;
  placement?: string;
  network?: string;
}

export interface DeviceTableRows {
  topData: string[];
  leftData: string[];
  bottomData: string[];
  selectedData: DeviceCell[][];
}

export interface ModalData {
  flights: string[];
  network?: string;
  placement?: string;
}
